<script>
import MultipleDatePicker from "./MultipleDatePicker";
import TimePicker from "./TimePicker";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    MultipleDatePicker,
    TimePicker
  },
  computed: {
    ...mapState("sendNotifications", [
      "schedule",
      "timeZone",
      "timeZoneOptions"
    ]),

    chipLabel() {
      return this.schedule
        ? "desative para enviar imediatamente"
        : "ative para programar o envio";
    },
    chipColor() {
      return this.schedule ? "default" : "primary";
    }
  },
  methods: {
    ...mapActions("sendNotifications", ["setSchedule", "setTimeZone"])
  }
};
</script>

<template>
  <v-layout column>
    <span class="mb-1">
      Ative para programar o envio ou mantenha desativado para enviar
      imediatamente.
    </span>

    <v-switch
      class="pl-3"
      color="primary"
      :value="schedule"
      @change="setSchedule"
      inset
    >
      <template v-slot:label>
        Programar envio
        <v-chip class="ml-1" :color="chipColor" small>{{ chipLabel }}</v-chip>
      </template>
    </v-switch>

    <v-slide-y-transition>
      <v-form v-show="schedule">
        <v-select
          dense
          filled
          required
          disabled
          name="timeZone"
          label="timezone"
          prepend-inner-icon="mdi-alarm-snooze"
          v-model="timeZone"
          v-validate="'required'"
          :items="timeZoneOptions"
          :error="errors.has('timeZone')"
          :error-messages="errors.first('timeZone')"
          @input="setTimeZone"
        />

        <multiple-date-picker />
        <time-picker />
      </v-form>
    </v-slide-y-transition>
  </v-layout>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Steps/Scheduling/Index.vue